module.exports = __webpack_public_path__ + "static/media/newinfo.f2ca552f.jpg";